module.exports = __webpack_public_path__ + "static/media/MALAYSIA.f0105e05.png";